var _defs, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 771.13 701.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    height: 1.242,
    width: 1.08,
    y: -0.121,
    x: -0.04,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.869
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    filter: "url(#a)",
    d: "M169.86 507.87c-20.785 77.131-51.799 144.5-72.654 221.61 2.102 4.674 8.867 1.05 12.719 2.188 233.25-.083 466.56.166 699.78-.125 4.297-2.586-1.121-8.655-1.008-12.491-20.23-74.16-48.44-142.55-68.69-216.7-196.02 0-373.71 4.036-569.73 4.036l-.27.96z",
    transform: "translate(-68.721 -58.594)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd3ba",
    d: "m677.729 439.986 62.933 230.64c.064.236-.237.441-.53.441H31.192c-.294 0-.593-.204-.53-.441l62.066-230.64z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.486,
    fill: "#89d375",
    d: "M658.009 668.856c0-1.114-3.322-4.215-5.067-4.731-2.319-.686-9.219-4.82-9.219-5.524 0-.31-.401-.577-.893-.594-2.656-.091-10.236-9.278-11.922-14.45-.65-1.993-1.598-3.063-3.646-4.107-1.522-.777-3.269-1.412-3.881-1.412-.612 0-2.795-.89-4.85-1.98s-5.665-2.567-8.022-3.287c-6.715-2.05-10.022-3.905-14.701-8.249-3.344-3.104-4.65-4.927-5.69-7.935-.74-2.149-1.358-4.42-1.371-5.05-.013-.628-.947-2.418-2.077-3.977s-2.276-3.536-2.548-4.393c-.272-.857-.794-1.558-1.16-1.558-.367 0-.667-.63-.667-1.402 0-1.904-6.756-8.343-10.714-10.212-1.768-.835-3.471-1.938-3.785-2.452-.314-.513-1.76-.934-3.215-.934-4.633-.001-20.857-4.909-20.857-6.31 0-.316-.959-1.65-2.131-2.963s-2.339-3.04-2.592-3.837c-.253-.797-1.704-3.483-3.225-5.968-2.682-4.381-2.766-4.718-2.777-11.113-.01-6.088-.73-9.77-2.503-12.786-.385-.655-3.272-2.439-6.415-3.963-3.142-1.523-6.622-3.37-7.733-4.105-1.688-1.115-4.088-1.419-14.643-1.852-13.358-.548-19.644-1.852-23.824-4.942-1.076-.796-2.226-1.446-2.556-1.446-.33 0-1.006-1.125-1.504-2.5s-1.365-2.5-1.929-2.5c-.564 0-1.025-.315-1.025-.7 0-.92-7.803-8.586-8.739-8.586-.618 0-8.47-3.756-13.047-6.241-.785-.427-3.357-1.148-5.714-1.602-4.772-.92-10.318-3.368-10.867-4.797-.197-.512-.725-.932-1.174-.932-1.401 0-4.496-4.516-5.024-7.33-.277-1.48-.528-7.88-.558-14.223-.053-11.366-.083-11.579-2.057-14.692-1.102-1.737-3.392-4.568-5.09-6.291s-4.616-4.711-6.484-6.64-4.835-4.832-6.593-6.453l-2.79-3.843h275l31.092 115.19c16.88 62.534 29.84 114.01 29.861 114.11.022.098-18.12.179-40.317.179s-40.357-.275-40.357-.61z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7fd9f",
    d: "M520.729 439.986h45l9.933 231.08h-65z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m712.729 565.026 10 40h-590l10-35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.729 440.026h40l-36.067 165.08h-50z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m677.729 439.986 62.933 230.64c.064.236-.237.441-.53.441H31.192c-.294 0-.593-.204-.53-.441l62.066-230.64z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "m677.729 439.986 62.933 230.64c.064.236-.237.441-.53.441H31.192c-.294 0-.593-.204-.53-.441l62.066-230.64z",
    stroke: "#000",
    strokeWidth: 10,
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 10.397,
    fill: "#e52626",
    d: "M383.359 5.191c-99.484 0-179.81 80.41-179.81 179.59 0 31.186 7.969 60.528 21.938 86.094l157.88 264.31 157.88-264.31c13.969-25.566 21.938-54.908 21.938-86.094 0-99.184-80.328-179.59-179.81-179.59zm-2 104.37c.667-.017 1.329 0 2 0 42.975 0 77.812 34.838 77.812 77.813s-34.838 77.812-77.812 77.812c-42.975 0-77.812-34.838-77.812-77.812 0-42.303 33.766-76.747 75.812-77.813z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.b704ffee0eba2562e7e09e98d35f8e16.svg";
export { ForwardRef as ReactComponent };